(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('grid-banner')) {
    class CollectionGridBanner extends HTMLElement {
      connectedCallback() {
        const grid = document.querySelector('.collection-listing .product-grid');
        if (!grid) return this.remove();
        const banner = this.querySelector('.collection-grid-banner');
        const position = parseInt(this.dataset.position, 10);
        const products = grid.querySelectorAll(':scope > .product-block');
        if (!banner || Number.isNaN(position)) return this.remove();
        if (position > 0 && position <= products.length) {
          grid.insertBefore(banner, products[position - 1]);
        } else {
          grid.appendChild(banner);
        }
        this.remove();
      }
    }
    customElements.define('grid-banner', CollectionGridBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  customElements.whenDefined('product-form').then(() => {
    if (customElements.get('swatch-form')) return;
    const ProductForm = customElements.get('product-form');
    class SwatchForm extends ProductForm {
      getSubmitForm() {
        return this.querySelector('.js-swatch-form');
      }
    }
    customElements.define('swatch-form', SwatchForm);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-feature-scroller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sl-scroller')) {
    customElements.define('sl-scroller', class SlScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sl-fs__track');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-dir="prev"]');
        this.nextBtn = this.querySelector('[data-dir="next"]');
        this.onUpdate = this.refresh.bind(this);
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.advance(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.advance(1));
        this.track.addEventListener('scroll', this.onUpdate, { passive: true });
        window.addEventListener('resize', this.onUpdate);
        this.refresh();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.onUpdate); }
      advance(dir) {
        const card = this.track.querySelector('.sl-fs__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      refresh() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft >= max - 2;
        if (max <= 2) { this.setAttribute('data-no-scroll', ''); } else { this.removeAttribute('data-no-scroll'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swatch-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sl-carousel')) {
    customElements.define('sl-carousel', class SlCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sl-car__track');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-dir="prev"]');
        this.nextBtn = this.querySelector('[data-dir="next"]');
        this.onUpdate = this.refresh.bind(this);
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.advance(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.advance(1));
        this.track.addEventListener('scroll', this.onUpdate, { passive: true });
        window.addEventListener('resize', this.onUpdate);
        this.refresh();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.onUpdate); }
      advance(dir) {
        const card = this.track.querySelector('.sl-car__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      refresh() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft >= max - 2;
        if (max <= 2) { this.setAttribute('data-no-scroll', ''); } else { this.removeAttribute('data-no-scroll'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
